import { Label } from "@/components/ui/label";

export interface FilmedByItem {
  key: string;
  /** Crew member name. */
  name: string;
  /** Crew function (optional). */
  fn?: string;
  /** For assistant mirror rows: the name they follow (optional). */
  sourceName?: string | null;
  filming_start: string;
  filming_end: string;
}

/**
 * Read-only "Filmed by" overview for the artist-detail popup: which crew film
 * this artist and from when to when. Shared by the edit schedule (CrewSchedule)
 * and the read-only producer schedule (ReadOnlyScheduleTimeline); each caller
 * shapes its own items, this owns the markup.
 */
export function FilmedByList({
  items,
  formatTime,
}: {
  items: FilmedByItem[];
  formatTime: (t: string) => string;
}) {
  if (items.length === 0) return null;

  return (
    <div>
      <Label className="text-muted-foreground">Filmed by</Label>
      <ul className="mt-1 space-y-1 text-sm">
        {items.map((item) => (
          <li key={item.key} className="flex items-center justify-between gap-2">
            <span className="truncate">
              {item.name}
              {item.fn ? ` · ${item.fn}` : ""}
              {item.sourceName ? (
                <span className="text-muted-foreground"> (follows {item.sourceName})</span>
              ) : null}
            </span>
            <span className="shrink-0 text-muted-foreground">
              {formatTime(item.filming_start)} - {formatTime(item.filming_end)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
